// extracted by mini-css-extract-plugin
export default {"container":"courses_container__89IxA","courseTable":"courses_courseTable__vMfk2","modal":"courses_modal__JoKY4","modal-content":"courses_modal-content__Nnx6K"};